module.exports = __webpack_public_path__ + "resources/60debde16cc531620d0edfb6608f1043.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/favicon.png
// module id = 213
// module chunks = 0